import DOMPurify from 'dompurify';
import { domPurifyConfig } from '../helpers/HTMLSanitizer';

let hooksInstalled = false;

const installHooks = () => {
  if (hooksInstalled) return;

  Object.keys(domPurifyConfig.hooks || {}).forEach((hookName) => {
    DOMPurify.addHook(hookName, domPurifyConfig.hooks[hookName]);
  });

  hooksInstalled = true;
};

const updateComponent = (el, binding) => {
  if (binding.oldValue === binding.value) return;

  installHooks();

  const namedConfigurations = domPurifyConfig.namedConfigurations || {};
  const configuration =
    binding.arg && namedConfigurations[binding.arg]
      ? namedConfigurations[binding.arg]
      : domPurifyConfig.default || {};

  el.innerHTML = DOMPurify.sanitize(binding.value || '', configuration);
};

export default {
  beforeMount: updateComponent,
  updated: updateComponent,
  unmounted(el) {
    el.innerHTML = '';
  },
};
